var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.862,
    height: 15.11,
    viewBox: "0 0 15.862 15.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    "data-name": "Icon metro-cross",
    d: "M18.288,14.067h0L13.476,9.483,18.288,4.9h0a.467.467,0,0,0,.113-.168.456.456,0,0,0-.113-.5L16.015,2.066a.513.513,0,0,0-.524-.108.5.5,0,0,0-.177.108h0L10.5,6.65,5.69,2.066h0a.5.5,0,0,0-.177-.108.513.513,0,0,0-.524.108L2.716,4.231a.456.456,0,0,0-.113.5.467.467,0,0,0,.113.168h0L7.528,9.483,2.716,14.067h0a.468.468,0,0,0-.113.168.456.456,0,0,0,.113.5L4.989,16.9a.513.513,0,0,0,.524.108A.5.5,0,0,0,5.69,16.9h0L10.5,12.316,15.314,16.9h0a.5.5,0,0,0,.177.108.513.513,0,0,0,.524-.108l2.273-2.165a.456.456,0,0,0,.113-.5.467.467,0,0,0-.113-.168Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7a9f38938c2f158645c2d5688e31973d.svg";
export { ForwardRef as ReactComponent };